// The booking wizard's wording in Ukrainian; keys match en.ts.
import type { en } from "./en";

export const uk = {
  // Page
  schedule_appointment: "Записатися на візит",
  powered_by: "Працює на",

  // Patient type
  new_or_existing: "Ви новий чи наявний пацієнт?",
  new_patient: "Новий пацієнт",
  existing_patient: "Наявний пацієнт",
  first_time_visiting: "Вперше в цьому кабінеті",
  been_here_before: "Я вже бував(ла) тут",

  // Appointment info
  what_type: "Який тип візиту?",
  no_types_available: "Наразі немає типів візитів, доступних для онлайн-запису.",
  minutes: "%{count} хвилин",
  additional_info: "Яку проблему чи занепокоєння ви хотіли б вирішити?",
  describe_concern: "Будь ласка, опишіть свою проблему...",

  // Provider
  pick_provider: "Виберіть лікаря",
  loading_providers: "Завантаження лікарів...",
  failed_load_providers: "Не вдалося завантажити лікарів. Спробуйте ще раз.",
  any_provider: "Будь-який лікар",
  show_all_available: "Показати всі доступні години",
  no_availability: "Немає вільних годин",

  // Time
  pick_a_time: "Виберіть час",
  finding_times: "Шукаємо вільні години...",
  no_times_for_date: "На цю дату немає вільних годин",
  slot_just_taken: "На жаль, цей час щойно зайняли. Будь ласка, виберіть інший.",
  jump_to_next: "До найближчого вільного",
  morning: "Ранок",
  afternoon: "День",
  cant_find_time: "Не знаходите зручний час? Зателефонуйте нам, і ми допоможемо його підібрати.",

  // Patient info
  your_information: "Ваші дані",
  first_name: "Ім'я",
  last_name: "Прізвище",
  preferred_name: "Бажане ім'я",
  optional: "Необов'язково",
  date_of_birth: "Дата народження",
  phone_number: "Номер телефону",
  required: "Обов'язково",
  invalid_phone: "Введіть дійсний 10-значний номер телефону",
  min_age: "Пацієнту має бути щонайменше 5 років",
  future_date: "Не може бути в майбутньому",
  referral_question: "Звідки ви про нас дізналися?",
  referral_prompt: "Виберіть варіант",
  referral_detail_who: "Хто вас направив?",
  referral_detail_other: "Розкажіть, як ви про нас дізналися",
  referral_detail_optional: "Додаткові відомості (необов'язково)",
  verification_disclaimer: "На цей номер буде надіслано код підтвердження.",
  phone_verified: "Телефон підтверджено",
  verifying: "Перевірка...",
  verify: "Підтвердити",
  invalid_code: "Недійсний код. Спробуйте ще раз.",
  sending: "Надсилання...",
  resend_code: "Надіслати код ще раз",
  email: "Електронна пошта",
  send_verification: "Надіслати код підтвердження",
  sending_code: "Надсилання коду...",

  // Insurance
  insurance_info: "Інформація про страхування",
  have_insurance: "Чи маєте ви страхування?",
  insurance_changed: "Чи змінилося ваше страхування з часу останнього візиту?",
  no_insurance_change: "Без змін",
  yes: "Так",
  no: "Ні",
  insurance_name: "Назва страхової",
  subscriber_name: "Ім'я застрахованої особи",
  subscriber_dob: "Дата народження застрахованої особи",
  subscriber_id: "Ідентифікаційний номер застрахованої особи",
  group_number: "Номер групи",
  select_option: "Будь ласка, виберіть варіант",
  card_photo_title: "Фото вашої страхової картки",
  card_photo_hint:
    "Додайте фото обох боків картки, щоб ми могли перевірити ваше страхування до візиту.",
  card_front: "Лицьовий бік картки",
  card_back: "Зворотний бік картки",
  add_photo: "Додати фото",
  uploading_photo: "Завантаження фото...",
  remove_photo: "Видалити",
  card_upload_failed: "Не вдалося додати фото. Спробуйте ще раз або продовжте без нього.",
  card_try_again: "Спробувати ще раз",

  // Review
  review_appointment: "Перевірте свій візит",
  appointment_details: "Деталі візиту",
  type_label: "Тип",
  provider: "Лікар",
  any_available: "Будь-який доступний",
  date_and_time: "Дата й час",
  notes: "Нотатки",
  patient_information: "Інформація про пацієнта",
  name: "Ім'я",
  phone: "Телефон",
  insurance: "Страхування",
  subscriber: "Застрахована особа",
  subscriber_id_label: "ID застрахованої особи",
  group_hash: "№ групи",
  no_insurance: "Без страхування",
  card_photos: "Фото картки",
  card_front_short: "Лицьовий бік",
  card_back_short: "Зворотний бік",
  waitlist: "Зв'яжіться зі мною, якщо з'являться раніші години",
  consent_prefix: "Записуючись, ви приймаєте наші ",
  terms: "Умови користування",
  consent_and: " та ",
  privacy: "Політику конфіденційності",
  consent_suffix:
    ". Надаючи номер телефону, ви погоджуєтеся отримувати текстові повідомлення. Може стягуватися плата за повідомлення та передавання даних.",
  scheduling: "Запис...",
  schedule_appointment_btn: "Записатися на візит",
  continue_to_payment: "Перейти до оплати",

  // Deposit
  deposit_title: "Сплатіть депозит",
  deposit_explainer:
    "Депозит %{amount} підтверджує цей візит. Його буде зараховано на ваш рахунок і застосовано до вашого візиту. Якщо ви не з'явитеся на візит, ви втратите депозит.",
  deposit_due: "Депозит",
  deposit_card_fee: "Комісія за картку",
  deposit_card_fee_notice:
    "Платежі кредитною карткою включають комісію за обробку %{percentage}%. Дебетові картки комісією не обкладаються.",
  deposit_total: "Разом",
  deposit_loading: "Завантаження безпечної оплати...",
  deposit_paying: "Обробка...",
  deposit_pay_and_book: "Сплатити та записатися",
  deposit_card_error: "Не вдалося прийняти ваш депозит. Перевірте дані картки та спробуйте ще раз.",
  deposit_unavailable:
    "Не вдалося завантажити безпечну оплату. Будь ласка, зателефонуйте до клініки.",
  deposit_needs_hold: "Не вдалося зарезервувати цей час. Будь ласка, оберіть час ще раз.",
  deposit_processing:
    "Ваш платіж усе ще підтверджується. Не платіть повторно — клініка невдовзі підтвердить ваш візит.",

  // Confirmation
  appointment_requested: "Ми отримали ваш запит на візит!",
  confirm_message:
    "Клініка розгляне його та надішле вам підтвердження. Якщо нам знадобиться додаткова інформація, наша команда зв'яжеться з вами.",
  date: "Дата",
  time: "Час",
  add_to_google: "Додати до Google Календаря",
  download_ics: "Завантажити файл календаря (.ics)",
  questions_call: "Є запитання? Зателефонуйте нам:",

  // Errors
  network_error: "Щось пішло не так. Спробуйте ще раз.",

  // Common
  back: "Назад",
  continue: "Продовжити",
  review: "Перевірити",

  // Step labels
  step_appointment: "Візит",
  step_provider: "Лікар",
  step_time: "Час",
  step_your_info: "Ваші дані",
  step_insurance: "Страхування",
} as const satisfies Record<keyof typeof en, string>;
